// extracted by mini-css-extract-plugin
export default {"main":"_5d18a8d8f3","tit":"_6f34f763b5","maintitle":"_8e6b31dc0d","ylw":"dfbb88a909","white":"_141f69fe7f","mv_title":"_40f3e9ad96","mv_nc":"_9d81609c50","mv_in":"a5d5cd9a4b"};